import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function Cursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.6 });
  const [scale, setScale] = useState(1);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX - 7);
      y.set(e.clientY - 7);
      const t = e.target;
      const interactive = t.closest('a, button, [data-cursor], input, select, textarea');
      const canvas = t.closest('[data-cursor="drag"]');
      setScale(canvas ? 4 : interactive ? 2.6 : 1);
    };
    window.addEventListener('mousemove', move);
    return () => window.removeEventListener('mousemove', move);
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      className="cursor-dot"
      style={{ x: sx, y: sy }}
      animate={{ scale }}
      transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      data-testid="custom-cursor"
    />
  );
}
